import { EditMode } from "PFApp/booking/types/edit_mode";
import { UNDETERMINED_FUTURE } from "PFApp/constants/dates";
import { PER_PAGE_UNPAGINATED } from "PFApp/constants/unpaginated";
import { useBookingPastDaysLimit } from "PFApp/hooks";
import { utc } from "PFCore/helpers/date";
import { useBookingsForUpdate } from "PFCore/hooks/queries/bookings/bulk_operation/use_bookings_for_update";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { BulkOperationFilter } from "PFCore/services/bookings_bulk_operation";
import { useEffect } from "react";

import { useBookingEditModeStoreActions, useEditMode } from "../booking_edit_mode_store";
import { useTotalSelection } from "../hooks/use_total_selection";

export const useSplitModeData = () => {
  const editMode = useEditMode();
  const totalSelectionFilter = useTotalSelection();

  const { splitMode } = useBookingEditModeStoreActions();

  const bookingPastDaysLimit = useBookingPastDaysLimit();
  const { formatISODate } = useDateFormatter();

  const preparePayload = (filters: BulkOperationFilter[]) => ({
    filters,
    dateRange: {
      min: formatISODate(utc().subtract(bookingPastDaysLimit, "days")),
      max: formatISODate(UNDETERMINED_FUTURE)
    },
    page: 1,
    perPage: PER_PAGE_UNPAGINATED
  });

  const isSplitModeActive = editMode === EditMode.Split;

  const { data, isFetching } = useBookingsForUpdate("split_mode", preparePayload(totalSelectionFilter), {
    enabled: isSplitModeActive && !!totalSelectionFilter,
    gcTime: 0,
    staleTime: 0,
    refetchOnMount: true
  });

  useEffect(() => {
    if (isSplitModeActive && data && !isFetching) {
      splitMode.addBookingIds(data.entries.map((entry) => entry.id));
    }
  }, [data, isFetching, isSplitModeActive, splitMode]);

  useEffect(() => {
    if (!isSplitModeActive) {
      splitMode.reset();
    }
  }, [isSplitModeActive, splitMode]);
};
